import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet(() => ({
  root: { minHeight: rh(64), flexDirection: 'row', alignItems: 'center', gap: rw(12), paddingHorizontal: rw(24) },
  content: { flex: 1, minWidth: 0 },
  amounts: { alignItems: 'flex-end' },
  amountRow: { flexDirection: 'row', alignItems: 'center', gap: rw(4) },
  cancelled: { opacity: 0.67 },
  strike: { textDecorationLine: 'line-through', opacity: 0.67 },
}))
